import React, { useEffect } from 'react';
import Meta from '../../../components/meta';
import { RequestADemoForm } from './request-a-demo-form/request-a-demo-form';

export const V2RequestADemo = () => {
  useEffect(() => {
    const $header = document.querySelector('header > div');
    if ($header) {
      $header.querySelector('a:not(:first-child)').style.display = 'none';
      $header.querySelector('nav').style.display = 'none';
    }

    return () => {
      const $header = document.querySelector('header > div');
      if ($header) {
        $header.querySelector('a:not(:first-child)').style.display = null;
        $header.querySelector('nav').style.display = null;
      }
    };
  }, []);

  return (
    <>
      <Meta
        title="Request a Demo | Voltaware"
        description="Request a demo of Voltaware’s Engagement-as-a-Service for utilities. See how AI-powered appliance-level insights boost customer engagement and reduce churn."
        url="https://voltaware.com/request-a-demo"
      />

      <RequestADemoForm />
    </>
  );
};
